import { API_URL } from './api';
import { authenticatedFetch } from '../utils/authenticatedFetch';
import { parseApiErrorResponse } from '../utils/reviewHelpers';

export interface GlacierAssignment {
  id: string;
  name: string;
}

export interface ClientConfig {
  companyId: string;
  companyCode: string;
  name: string;
  logo: string;
  color: string;
  glaciers: GlacierAssignment[];
  cameras: string[];
  seasonYear?: number;
  seasonStart?: string;
  replenishmentDataThrough?: string;
  weeklyReportDataThrough?: string;
  role?: string;
  description?: string;
  goal?: number;
}

interface ClientConfigResponse {
  company_id: string;
  company_code: string;
  display_name: string;
  logo_uri?: string | null;
  goal_m3?: number | null;
  season_year?: number | null;
  season_start?: string | null;
  replenishment_data_through?: string | null;
  weekly_report_data_through?: string | null;
  role?: string;
  glaciers: GlacierAssignment[];
  cameras: string[];
}

export const loadClientConfig = async (previewCompanyCode?: string): Promise<ClientConfig> => {
  const path = previewCompanyCode
    ? `/admin/commercial/customers/${encodeURIComponent(previewCompanyCode)}/config`
    : '/client/me/config';
  const response = await authenticatedFetch(`${API_URL}${path}`);
  if (!response.ok) {
    throw new Error(await parseApiErrorResponse(response, 'Unable to load company configuration'));
  }
  const data: ClientConfigResponse = await response.json();
  const fallbackLogo = data.company_code.toLowerCase() === 'coke'
    ? '/images/sponsor_logos/coke-two-line.png'
    : '';
  return {
    companyId: data.company_id,
    companyCode: data.company_code,
    name: data.display_name,
    logo: data.logo_uri || fallbackLogo,
    color: '#1976d2',
    glaciers: data.glaciers,
    cameras: data.cameras,
    seasonYear: data.season_year ?? undefined,
    seasonStart: data.season_start ?? undefined,
    replenishmentDataThrough: data.replenishment_data_through ?? undefined,
    weeklyReportDataThrough: data.weekly_report_data_through ?? undefined,
    role: data.role,
    description: 'Strategic Environmental Partner',
    goal: data.goal_m3 ?? undefined,
  };
}; 